// -----------
// Email

export function validateEmail(value: string) {
  if (
    /^(?!.*\.\.)([A-Za-z0-9!#$%&‘*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&‘*+/=?^_`{|}~-]+)*)@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)\.)+[A-Za-z]{2,}$/
      .test(value)
  ) {
    return undefined;
  }
  return 'Невалидный E-mail';
}

// -----------
// ClubId

export function validateClubId(value: string) {
  if (/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)) {
    return undefined;
  }
  return 'Допустимы только строчные латинские буквы, цифры и дефис';
}
